import React, { Fragment } from 'react';

import '../../css/crispify.css';

import { crispify } from '../../services/ipaClient';
import CrispifyModal from './crispifyModal';
import ImageLoader from '../ImageLoader';
import ImageSelection from '../imageSelection';
import ApiTab from '../ApiTab';
import ToggleButtons from '../ToggleButtons';
import Slider from '../Slider';

export default class Crispify extends ApiTab {
    state = {
        image: '',
        superResolution: true,
        texture: 0,
        modalOpen: false,
        url: '',
    }

    setVariable(variable, value) {
        this.setState({ [variable]: value }, this.updateCrispify);
    }

    updateCrispify = () => {
        const { image, superResolution, texture } = this.state;
        return crispify({ imageUrl: image, superResolution, texture })
            .then(url => this.setState({ url }));
    }

    showModal = () => {
        this.setState({ modalOpen: true });
    }

    hideModal = () => {
        this.setState({ modalOpen: false });
    }

    renderLeft = () => (
        <Fragment>
            <ImageSelection {...this.valueLink('image')} />
            <div>Double Resolution</div>
            <ToggleButtons
                className='resolution-control'
                options={[{ value: true, label: 'true' }, { value: false, label: 'false' }]}
                {...this.valueLink('superResolution', true)}
                style={{ borderLeft: 0, paddingLeft: 0 }}
            />
            <Slider min={0} max={1} {...this.valueLink('texture', true)} increment={0.01} label='Texture' />
        </Fragment>
    )

    renderTitle = () => (
        <Fragment>
            Clean up and increase resolution of images to make them look better both on screen and on a final product.
            With the proper parameter settings, it can handle RGB images of any type: textureless (typically line art/logos) or containing textures (such as photos).
            If type of the image is not known beforehand (line art/logo vs photo), one can use Cartoon Classification service to figure out whether texture needs
            to be preserved during the processing. The service employs state-of-the-art algorithms for cleanup and super-resolution and resulting images usually
            considerably better (but not worse in other cases) when compared to the traditional techniques.
        </Fragment>
    )

    renderRight = () => {
        const { image, url, modalOpen: show, superResolution, texture } = this.state;
        return (
            <Fragment>
                <ImageLoader className='crispify-image' url={image} alt='original rendered preview' />
                <div className='rendered-fragment__label'>Original Preview</div>
                <ImageLoader className='crispify-image' url={url} alt='crisp rendered preview' />
                <div className='rendered-fragment__label'>Crispified Preview</div>
                <button className='btn btn-primary' onClick={this.showModal}>How do I use this?</button>
                <CrispifyModal show={show} superResolution={superResolution} texture={texture} imageUrl={image} onClose={this.hideModal} />
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/crispify/index.jsx